import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BackArrowIcon2, Back_img, Brandicon, Settings, scrollxLogo, scrollx_icon } from "../assets/icons";
import Setting from "../Pages/Setting/Setting";

export default function Navbar_back_btn() {
  const [isSettingOpen, setIsSettingOpen] = useState(false);

  return (
    <div className="w-[100%] h-[64px] renderNavContainer flex items-center bg-[#212226]  justify-between drop-shadow-xl">
      <div className=" ml-8 w-[200px]">
        <Link className="flex items-center" to="/home/dashboard">
        <img
            className="pl-[14px]   w-[49px]"
            src={BackArrowIcon2}
            alt=""
            style={{ cursor: "pointer" }}
          />
              <img className="pro_navabr_home2 mr-[.1rem]" src={scrollxLogo} />
              <h1 className="Syne text-xl font-extrabold tracking-wide ml-[-0.4rem] text-white">
              {" "}
              ScrollX.io
            </h1>
        </Link>
      </div>

      <div className=" mr-[120px] w-[100px]">
        {/* <img src={Brandicon} style={{ width: "35px" }} /> */}
      </div>

      <div className=" mr-[0px] w-[80px] ">
        {/* <img src={Settings} style={{ width: "30px" }} /> */}
        <button onClick={() => setIsSettingOpen(true)}>
          {/* <img src={Settings} style={{ width: "30px" }} /> */}
        </button>
        <div className="absolute right-[15%] z-40 ">
          <Setting
            isSettingOpen={isSettingOpen}
            setIsSettingOpen={setIsSettingOpen}
          />
        </div>
      </div>
    </div>
  );
}
